import { render, staticRenderFns } from "./FormBulky.vue?vue&type=template&id=1ef0c9ea"
import script from "./FormBulky.vue?vue&type=script&lang=js"
export * from "./FormBulky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports